// extracted by mini-css-extract-plugin
module.exports = {"main":"category__main___24T3p","fixedQrcode":"category__fixedQrcode___34LXN","pagination":"category__pagination___1U-Bc"};